import { html, LitElement, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import style from './ui-paysafe-icon.css?inline';
import '../../ui-inlined-svg/ui-inlined-svg';

const CName = 'ui-paysafe-icon';

@customElement(CName)
export class UIPaysafeIcon extends LitElement {
  static readonly styles = unsafeCSS(style);

  @property({ type: String }) class = '';
  @property({ type: String }) label = '';

  render() {
    // Use vite to transform static URL
    const assetUrl = new URL('/assets/ui-core/icons/payment/paysafe-icon.svg', import.meta.url).href;
    return html`
      <ui-inlined-svg class="ui-paysafe-icon ${this.class}" .defer=${true} .src=${assetUrl} .label=${this.label}></ui-inlined-svg>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UIPaysafeIcon;
  }
}
